import API from '@/axios'
const Endpoint = '/models/addons'

import { AxiosResponse } from 'axios'
import { IAddonsPayload, IAddonsResponse } from './types'
import { ITypeOrmPaginationTemplate } from '@/utils/interfaces/typeormPagination'
import { IAddonsFilters } from '../store/types'

export default {
	async getAddons(
		filters: IAddonsFilters
	): Promise<AxiosResponse<ITypeOrmPaginationTemplate<IAddonsResponse>>> {
		return await API.get(Endpoint, { params: filters })
	},

	async createAddon(payload: IAddonsPayload): Promise<AxiosResponse<IAddonsResponse>> {
		return await API.post(Endpoint, payload)
	},

	async updateAddon({
		id,
		payload,
	}: {
		id: string
		payload: IAddonsPayload
	}): Promise<AxiosResponse<IAddonsResponse>> {
		return await API.patch(`${Endpoint}/${id}`, payload)
	},

	async removeAddon(id: string): Promise<AxiosResponse<{ message: string }>> {
		return await API.delete(`${Endpoint}/${id}`)
	},

	async changeActiveAddon({
		id,
		active,
	}: {
		id: string
		active: boolean
	}): Promise<AxiosResponse<IAddonsResponse>> {
		return await API.patch(`${Endpoint}/${id}/active`, { active })
	},

	async getAddonExams(addonId: string): Promise<AxiosResponse<any>> {
		return await API.get(`${Endpoint}/${addonId}/exams`)
	},
}
